import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const OffersBenefitsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 1200px;
  border-radius: 16px;
  padding: 40px;
  margin: 0 auto;
  background: linear-gradient(
    251.57deg,
    #5483bc 0%,
    #ffffff 19.31%,
    #e3ebf4 27.82%,
    #ffffff 45.19%
  );
`;

export const OffersBenefitsSectionTitle = styled.div`
  color: ${theme.blackText};
  font-weight: 900;
  font-size: 32px;
`;

export const OffersBenefitsSectionDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${theme.greyText};
  width: 80%;
`;

export const OffersBenefitsSectionCards = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: auto;
`;

export const OffersBenefitsSectionCardBadge = styled.div<{
  bgGradient: string[];
}>`
  padding: 2px 8px;
  border-radius: 100px;
  background: linear-gradient(90deg, ${(props) => props.bgGradient.join(",")});
  font-weight: 900;
  font-size: 12px;
  color: ${theme.whiteText};
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-50%) translateX(33%);
`;

export const OffersBenefitsSectionCardTitle = styled.div`
  font-size: 24px;
  color: ${theme.blackText};
  font-weight: 900;
  font-size: 24px;
`;

export const OffersBenefitsSectionCardDesc = styled.div`
  font-weight: 900;
  color: linear-gradient(225deg, #3023ae 0%, #c86dd7 100%);
  font-size: 12px;
`;

export const OffersBenefitsSectionCardBenefitImg = styled.img`
  width: auto;
  height: 81px;
  object-fit: cover;
  border-radius: 16px;
`;

export const OffersBenefitsSectionCardBenefitInfo = styled.p`
  color: ${theme.greyText};
  font-weight: 400;
  font-size: 14px;
`;

export const OffersBenefitsSectionCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: -webkit-fill-available;
  width: 268px;
  gap: 16px;
  border-radius: 20px;
  padding: 24px;
  border: 1px solid #d8d8d8;
  background: ${theme.whiteText};
  position: relative;
`;
